
import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

import useUserData from "../user/useUserData";
import { handleAxiosErrors } from "../../helpers/errorHandling";
import { enqueueSnackbar } from "notistack";
import { API } from "../../helpers/constants";
import { PAGE_LOGIN } from "../../locales/pages/namespaces";

export const useAddresses = () => {
    const [loading, setLoading] = useState(false);
    const [addresses, setAddresses] = useState(null);
    const [countries, setCountries] = useState(null);
    const { token } = useUserData();
    const { t } = useTranslation(PAGE_LOGIN);

    useEffect(() => {
        if (!token) return;

        setLoading(true);

        axios({
            method: "get",
            url: `${API}/en/brew/address/data`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        })
            .then((res) => {
                const { addresses, countries } = res.data.data;

                setAddresses(res.data || []);
                setCountries(countries || []);

                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                enqueueSnackbar(handleAxiosErrors(error, t("An error occurred!")), {
                    variant: "error",
                    autoHideDuration: 3000,
                });
            });
    }, [token, t]);


    return {
        addresses,
        countries,
        loading,

    };
};